/**
 * Wait for an element to appear in the DOM by its ID.
 * Used for tour navigation to ensure target elements exist before showing tooltips.
 *
 * @param elementId - The ID of the element to wait for
 * @param timeout - Maximum time to wait in milliseconds (default: 2500ms)
 * @param interval - Polling interval in milliseconds (default: 50ms)
 * @returns Promise that resolves to true if element found, false if timeout
 */
export const waitForElementById = (
  elementId: string,
  timeout = 2500,
  interval = 50,
): Promise<boolean> => {
  if (typeof document === "undefined") {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    if (!elementId) {
      resolve(true)
      return
    }

    const startTime = performance.now()

    const check = () => {
      if (document.getElementById(elementId)) {
        resolve(true)
        return
      }

      if (performance.now() - startTime >= timeout) {
        console.warn(
          `[Onboarding] Element #${elementId} not found within ${timeout}ms`,
        )
        resolve(false)
        return
      }

      setTimeout(check, interval)
    }

    check()
  })
}

/**
 * Get the current URL path including search params
 */
export const getCurrentPath = (): string => {
  if (typeof globalThis.window === "undefined") {
    return "/"
  }

  const { pathname, search } = globalThis.window.location
  return `${pathname}${search}`
}
